/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1BrandingVersionEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_BRANDING_VERSION_EVENT_ENTITY_NAME = 'ixm.userauth.v1.BrandingVersionEvent';
export const ixmUserauthV1BrandingVersionEventEntity = new schema.Entity<IxmUserauthV1BrandingVersionEvent>(IXM_USERAUTH_V1_BRANDING_VERSION_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxmUserauthV1BrandingVersionEvent) => `${entity.metadata?.eventId}` });

